import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, Package, ArrowRight, Award } from 'lucide-react';
import { getOrderById, verifyPayment } from '../api/orderAPI';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './OrderSuccessPage.css';

const OrderSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const orderId = searchParams.get('orderId');
  const reference = searchParams.get('reference');

  useEffect(() => {
    if (reference) {
      handleVerifyPayment();
    } else if (orderId) {
      fetchOrder();
    }
  }, []);

  const handleVerifyPayment = async () => {
    try {
      await verifyPayment(reference);
      await fetchOrder();
    } catch (error) {
      setLoading(false);
    }
  };

  const fetchOrder = async () => {
    try {
      const response = await getOrderById(orderId);
      if (response.success) setOrder(response.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <>
        <Navbar />
        <div className="success-page">
          <div className="success-loading">
            <div className="spinner" />
            <p>Confirming your order...</p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="success-page">
        <div className="success-card">
          <div className="success-icon">
            <CheckCircle size={48} color="#10B981" />
          </div>

          <h1>Order Placed Successfully!</h1>
          <p className="success-subtitle">
            Thank you for your order. We'll process it right away.
          </p>

          {order && (
            <>
              <div className="order-details">
                <div className="order-detail-row">
                  <span>Order Number</span>
                  <strong>#{order.id}</strong>
                </div>
                <div className="order-detail-row">
                  <span>Total Paid</span>
                  <strong>GHS {order.totalAmount?.toFixed(2)}</strong>
                </div>
                <div className="order-detail-row">
                  <span>Payment Status</span>
                  <span className={`status-badge ${
                    order.paymentStatus === 'PAID'
                      ? 'badge-green' : 'badge-yellow'
                  }`}>
                    {order.paymentStatus}
                  </span>
                </div>
                <div className="order-detail-row">
                  <span>Order Status</span>
                  <span className="status-badge badge-blue">
                    {order.status}
                  </span>
                </div>
                <div className="order-detail-row">
                  <span>Delivery Address</span>
                  <span>{order.deliveryAddress}</span>
                </div>
              </div>

              {order.pointsEarned > 0 && (
                <div className="points-earned-banner">
                  <Award size={20} color="#1565C0" />
                  <div>
                    <p className="points-earned-title">
                      You earned {Math.floor(order.pointsEarned)} Aurora Points!
                    </p>
                    <p className="points-earned-sub">
                      Points have been added to your wallet
                    </p>
                  </div>
                </div>
              )}

              <div className="order-items-summary">
                <h3>Items Ordered</h3>
                {order.items?.map((item, index) => (
                  <div key={index} className="order-item-row">
                    <span>{item.productName} x{item.quantity}</span>
                    <span>GHS {item.totalPrice?.toFixed(2)}</span>
                  </div>
                ))}
              </div>
            </>
          )}

          <div className="success-actions">
            <a
              href="https://app.auroragh.com/orders"
              className="track-order-btn"
            >
              <Package size={18} />
              Track My Order
            </a>
            <Link to="https://auroragh.com/shop" className="continue-shopping-btn">
              Continue Shopping <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OrderSuccessPage;